"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiMetricDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var safeSerializeObjRef_1 = require("../../../../../_staging/metadata/safeSerializeObjRef");
var MetricDropdown_1 = require("./MetricDropdown");
exports.KpiMetricDropdown = function (props) {
    var widget = props.widget, onMeasureChange = props.onMeasureChange;
    var workspace = sdk_ui_1.useWorkspaceStrict();
    var measureRef = widget === null || widget === void 0 ? void 0 : widget.kpi.metric;
    var _a = tslib_1.__read(react_1.useState(measureRef), 2), selectedMeasure = _a[0], setSelectedMeasure = _a[1];
    var selectedItems = react_1.useMemo(function () { return (selectedMeasure ? [selectedMeasure] : []); }, [selectedMeasure]);
    var handleMeasureChanged = react_1.useCallback(function (measure) {
        onMeasureChange(measure.ref);
        setSelectedMeasure(measure.ref);
    }, [onMeasureChange]);
    react_1.useEffect(function () {
        setSelectedMeasure(measureRef);
    }, [safeSerializeObjRef_1.safeSerializeObjRef(measureRef)]);
    return (react_1.default.createElement(MetricDropdown_1.MetricDropdown, { workspace: workspace, openOnInit: !measureRef, bodyClassName: "configuration-dropdown metrics-list s-metrics-list", selectedItems: selectedItems, onSelect: handleMeasureChanged }));
};
//# sourceMappingURL=KpiMetricDropdown.js.map